import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-branch-analysis-report',
  templateUrl: './branch-analysis-report.component.html',
  styleUrls: ['./branch-analysis-report.component.scss']
})
export class BranchAnalysisReportComponent implements OnInit {

  constructor(public reportService : ReportService) { }

  ngOnInit(): void {
  }

}
